(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-jw-gallery]').forEach(gallery => {
      if (gallery.dataset.jwGalleryReady) return;
      gallery.dataset.jwGalleryReady = 'true';
      let frame;
      let interacted = false;
      const initialSlide = gallery.querySelector('img[fetchpriority="high"]')?.closest('[data-main-slide]');
      const interactionScope = gallery.closest('.t4s-product__media-wrapper') || gallery;
      const load = (slide, selected) => {
        slide?.querySelectorAll('img.jw-native-media').forEach(image => {
          if (selected) image.setAttribute('fetchpriority', 'high');
          if (!image.hasAttribute('data-jw-src')) return;
          image.loading = 'eager';
          image.setAttribute('fetchpriority', selected ? 'high' : 'low');
          image.srcset = image.dataset.jwSrcset;
          image.src = image.dataset.jwSrc;
          image.removeAttribute('data-jw-srcset');
          image.removeAttribute('data-jw-src');
        });
      };
      const update = () => {
        const slides = [...gallery.querySelectorAll('[data-main-slide]')]
          .filter(slide => !slide.classList.contains('is--media-hide'));
        if (!slides.length) return;
        let index = slides.findIndex(slide => slide.classList.contains('is-selected'));
        if (index < 0) index = slides.indexOf(initialSlide);
        if (index < 0) index = 0;
        load(slides[index], true);
        if (interacted && slides.length > 1) {
          load(slides[(index + 1) % slides.length], false);
          load(slides[(index - 1 + slides.length) % slides.length], false);
        }
      };
      const observer = new MutationObserver(() => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = undefined;
          update();
        });
      });
      observer.observe(gallery, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
      const onInteraction = () => {
        if (interacted) return;
        interacted = true;
        gallery.setAttribute('data-jw-gallery-interacted', '');
        update();
      };
      interactionScope.addEventListener('pointerdown', onInteraction, {passive: true});
      interactionScope.addEventListener('keydown', onInteraction);
      interactionScope.addEventListener('focusin', onInteraction);
      const onUnload = event => {
        if (!event.target.contains(gallery)) return;
        observer.disconnect();
        if (frame) cancelAnimationFrame(frame);
        interactionScope.removeEventListener('pointerdown', onInteraction);
        interactionScope.removeEventListener('keydown', onInteraction);
        interactionScope.removeEventListener('focusin', onInteraction);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), {once: true});
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
